import React, { useRef } from "react"

import {
  Dialog,
  Paper
} from "@mui/material"

import { styled } from "@mui/material/styles"

import "./HKVDialog.css"
import Draggable from "react-draggable"

const StyledPaper = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "dialogSize" && prop !== "scrollPaper",
})(({ theme, dialogSize, sx }) => {
  const sizes = {
    xs: 440,
    sm: 660,
    md: 960,
    lg: 1260,
    xl: 1600,
    full: "100%"
  }
  const maxWidth = sizes[dialogSize] || 960

  return {
    ...sx,
    display: "flex",
    flexDirection: "column",
    // claude: 100% van de viewport-breedte, terwijl de persistente app-drawer (App.js, altijd 56px
    // breed, ook ingeklapt) links een vaste strook inneemt — zonder deze correctie kan de dialoog op
    // smallere schermen (waar width de effectieve grens wordt i.p.v. maxWidth) links onder die drawer
    // schuiven.
    width: "calc(100% - 56px)",
    maxWidth: maxWidth,
    margin: theme.spacing(4),
    [theme.breakpoints.down(maxWidth + 32)]: {
      margin: 0,
      maxHeight: "100%",
      borderRadius: 0
    },
    [theme.breakpoints.up(maxWidth + 32)]: {
      maxHeight: `calc(100% - ${theme.spacing(8)})`
    }
  }
})

const DraggablePaper = (props) => {
  const nodeRef = useRef(null)

  return <Draggable nodeRef={nodeRef} handle=".draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
    <StyledPaper
      {...props}
      ref={nodeRef}
      sx={{ ...props.sx, pointerEvents: "auto" }}
    >
      {props.children}
    </StyledPaper>
  </Draggable>
}

const StyledDialog = styled(Dialog)({
  "& .MuiDialog-container": {
    flexDirection: "column"
  }
})

function HKVDialog(props) {
  const {
    config,
    draggable,
    noPaper,
    onClose,
    children
  } = props

  if (!config) return null

  if (draggable) {
    const alignItems = {
      topLeft: "flex-start",
      topRight: "flex-end",
      bottomRight: "flex-end",
      bottomLeft: "flex-start"
    }

    const justifyContent = {
      topLeft: "flex-start",
      topRight: "flex-start",
      bottomRight: "flex-end",
      bottomLeft: "flex-end"
    }

    return (
      <StyledDialog
        open={config.open}
        onClose={(event, reason) => onClose && reason !== "backdropClick" ? onClose() : null}
        disableEnforceFocus
        disableRestoreFocus
        disablePortal
        hideBackdrop
        maxWidth={false}
        slots={{
          paper: DraggablePaper
        }}
        slotProps={{
          container: {
            sx: {
              alignItems: alignItems[config.scrollPaper] || "flex-end",
              justifyContent: justifyContent[config.scrollPaper] || "flex-end",
            }
          },
          paper: {
            dialogSize: config.size
          }
        }}
        sx={{ pointerEvents: "none" }}
      >
        {children}
      </StyledDialog>
    )
  } else {
    return (
      <StyledDialog
        open={config.open}
        onClose={(event, reason) => onClose && reason !== "backdropClick" ? onClose() : null}
        disableRestoreFocus
        disablePortal
        maxWidth={false}
        slots={{
          paper: noPaper ? "div" : StyledPaper
        }}
        slotProps={{
          paper: {
            dialogSize: config.size,
            sx: props.sx || {}
          }
        }}
      >
        {children}
      </StyledDialog>
    )
  }
}

export default HKVDialog